module.exports = __webpack_public_path__ + "static/media/bunnylever-2@2x.8f41f729.png";